import TaxCenter from './TaxCenter'

export default TaxCenter
